import { DropdownMenuItem } from '@/atoms/DropdownMenu/DropdownMenu';
import { Link } from '@/atoms/Link/Link';
import { ResourceRowContent } from './ResourceRowContent';

const ROW_CLASS_NAME = 'gap-2 hover:bg-accent focus:bg-accent';

interface ResourceMenuRowProps {
  /** The URI the row's icon is read from. */
  uri: string;
  /** Where the row opens (`http(s)` only); `null` lists it as text. */
  href: string | null;
  name: string;
  /** A second line under the name, or `null` for none. */
  note: string | null;
  testId: string;
}

/**
 * One row of a card's menu (Also on, Similar): favicon or identifier icon, a name and a note.
 * A row without a web link (`isbn:`, `pubky://`) has nowhere to open: it is listed, not linked.
 */
export function ResourceMenuRow({ uri, href, name, note, testId }: ResourceMenuRowProps) {
  const content = <ResourceRowContent uri={uri} name={name} note={note} />;

  if (!href) {
    return (
      <DropdownMenuItem disabled data-testid={testId} className={ROW_CLASS_NAME}>
        {content}
      </DropdownMenuItem>
    );
  }
  return (
    <DropdownMenuItem asChild data-testid={testId} className={ROW_CLASS_NAME}>
      <Link href={href} overrideDefaults>
        {content}
      </Link>
    </DropdownMenuItem>
  );
}
